<template>
  <span class="current-version-badge text-caption text-info rounded-pill">
    {{ label }}
  </span>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: 'Current version',
  },
});
</script>

<style scoped lang="less">
.current-version-badge {
  padding: 2px 6px;
  background-color: @bg-info-light;
}
</style>
